import React from 'react';
import * as T from '../Typography';
import * as S from './style';
import composeStyle from '../../utils/composeStyle';

const Component = composeStyle(T.H2, 'H3', 'H4Bold');
const CategoryComponent = composeStyle(T.H4SemiBold, 'H6Caps14', 'H6Caps14');

const PostTitle = ({ children, category }) => {
  return (
    <S.Wrapper>
      {category && (
        <CategoryComponent color="pink" mb={1} mbT={0} mbM={0} caps>
          {category}
        </CategoryComponent>
      )}
      <Component color="midnight">{children}</Component>
    </S.Wrapper>
  );
};

export default PostTitle;
